export default __webpack_public_path__ + "static/media/snack-1.8d553cb8.jpg";